import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { PagesModule } from './@pages/pages.module';
import { ActivateUserComponent } from './activate-user/activate-user.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ChangePassComponent } from './change-pass/change-pass.component';
import { ForgottenComponent } from './forgotten-pass/forgotten-pass.component';
import { GraphQLModule } from './graphql.module';
import { Interceptor } from "./interceptor/interceptor";
import { LoginComponent } from './login/login.component';
import { PagesNotFoundComponent } from './pages-not-found/pages-not-found.component';

import { ButtonModule } from 'primeng/button';
import { PasswordModule } from 'primeng/password';
import { ToastModule } from 'primeng/toast';

import { registerLocaleData } from "@angular/common";
import localeEs from "@angular/common/locales/es";
import { ConfirmationService, MessageService } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';
import { newCountryComponent } from './@pages/country/new/new-country.component';
import { NewProvinceComponent } from './@pages/province/new/new-province.component';
import { NewTownComponent } from './@pages/town/new/new-town.component';

registerLocaleData(localeEs);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ForgottenComponent,
    ChangePassComponent,
    ActivateUserComponent,
    PagesNotFoundComponent,
    newCountryComponent,
    NewProvinceComponent,
    NewTownComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    GraphQLModule,
    HttpClientModule,
    PagesModule,
    ButtonModule,
    ToastModule,
    PasswordModule,
    InputTextModule,
   
  ],

  exports: [
    NewProvinceComponent,
    newCountryComponent,
    NewTownComponent
  ],

  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true, 
    },
    { provide: LOCALE_ID, useValue: "es" },
    MessageService,
    ConfirmationService
  ],
  
  bootstrap: [AppComponent]
})
export class AppModule { }
